import { IconProps } from "types/StylesTypes";

export const GuidedPortfoliosIcon: React.FC<IconProps> = ({
  color = "currentColor",
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="7" width="18" height="13" rx="2" stroke={color} strokeWidth="2" />
      <path
        d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path d="M3 12h18" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};
